module.exports = __webpack_public_path__ + "img/slide2.a25d1dfb.webp";